(function () {

const corner = document.getElementById('logo-symbol');

if (corner) {
    window.onscroll = function(e) {
        corner.className = (this.scrollY < 16)? '' : 'small';
    }
}

function updateProgress() {
    const totalHeight = document.body.clientHeight;
    const windowHeight = document.documentElement.clientHeight;
    const position = window.scrollY;
    const progress = position / (totalHeight - windowHeight) * 100;
    progressBar.setAttribute('value', progress);
    requestAnimationFrame(updateProgress);
}

const progressBar = document.querySelector('.reading-progress');

if (progressBar) requestAnimationFrame(updateProgress);

[...document.querySelectorAll(".gh-article a[href^='http://']")].forEach(link => {
    link.setAttribute("target", "moredetail");
});
[...document.querySelectorAll(".gh-article a[href^='https://']")].forEach(link => {
    link.setAttribute("target", "moredetail");
});

})();
